import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Grid,
  Container,
  Button,
  Typography,
  FormControl,
  Box,
  ListItem,
} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import { Image } from "@material-ui/icons";
import MomsImageModal from "./modals/MomsImageModal";

function capitalizeFirstLetter(str, every_word = false) {
  let capitalize;
  if (str) {
    capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  }

  if (every_word) {
    const arr = str.split(" ");
    const cap_arr = arr.map((s) => capitalize(s));

    return cap_arr.join(" ");
  }

  return str ? capitalize(str) : "";
}

const MomsTable = (props) => {
  const { instances } = props;
  const [isOpen, setOpenModal] = useState(false);
  const [selectedMomsImage, setSelectedMomsImage] = useState(null);
  const [featureName, setFeatureName] = useState(null);

  const openModal = () => {
    setOpenModal(true);
  };
  return (
    <Grid cointainer width={"100%"}>
      <Grid item xs={12}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell align="center">Feature Type</TableCell>
              <TableCell align="center">Feature Name</TableCell>
              <TableCell align="center">Location</TableCell>
              <TableCell align="center">Last Observance Timestamp</TableCell>
              <TableCell align="center">Determined Alert Level</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {instances.hasOwnProperty("data") > 0 &&
              instances.data
                .sort((a, b) => {
                  return (
                    new Date(b.moms[0].observance_ts) -
                    new Date(a.moms[0].observance_ts)
                  );
                })
                .map(
                  (row) =>
                    row.moms.length > 0 && (
                      <Row
                        key={row.date}
                        row={row}
                        openModal={openModal}
                        setOpenModal={setOpenModal}
                        setFeatureName={setFeatureName}
                        setSelectedMomsImage={setSelectedMomsImage}
                      />
                    )
                )}
          </TableBody>
        </Table>
        {/* <FabMuiTable
                data={{
                  columns: columns,
                  rows: dummyData,
                }}
                options={options}
              /> */}
      </Grid>

      <MomsImageModal
        momsImage={selectedMomsImage}
        featureName={featureName}
        setOpenModal={setOpenModal}
        isOpen={isOpen}
      />
    </Grid>
  );
};

function Row(props) {
  const { row, openModal, setOpenModal, setFeatureName, setSelectedMomsImage } =
    props;
  const [open, setOpen] = React.useState(false);
  const openMomsImageModal = (selected) => {
    setSelectedMomsImage(selected.files);
    setFeatureName(
      `${capitalizeFirstLetter(
        row.feature.feature_type
      )} - ${capitalizeFirstLetter(row.feature_name)}`
    );
    openModal();
  };
  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" },
          backgroundColor: open ? "#E0E0E0FD" : "none",
        }}
        onClick={() => setOpen(!open)}
      >
        <TableCell style={{ width: 2 }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {capitalizeFirstLetter(row.feature.feature_type)}
        </TableCell>
        <TableCell align="center">{row.feature_name}</TableCell>
        <TableCell align="center">
          {capitalizeFirstLetter(row.location)}
        </TableCell>
        <TableCell align="center">
          {moment(row.moms[0].observance_ts).format("LL hh:mm A")}
        </TableCell>
        <TableCell align="center">Alert {row.moms[0].op_trigger}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 5 }}>
              <Typography variant="h6" gutterBottom component="div">
                {`${row.feature.feature_type.toUpperCase()}  ${
                  row.feature_name
                }`}
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Observance Timestamp</TableCell>
                    <TableCell>Feature Description</TableCell>
                    <TableCell align="center">Report Timestamp</TableCell>
                    <TableCell align="center">Reporter</TableCell>
                    {/* <TableCell>Validator</TableCell> */}
                    <TableCell>Narratives</TableCell>
                    <TableCell align="center">Recommended Alert Level</TableCell>
                    <TableCell align="center">Determined Alert Level</TableCell>
                    <TableCell align="center">Image</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.moms
                    .sort((a, b) => {
                      return (
                        new Date(b.observance_ts) - new Date(a.observance_ts)
                      );
                    })
                    .map((element) => (
                      <TableRow key={element.moms_id}>
                        <TableCell align="center" component="th" scope="row">
                          {moment(element.observance_ts).format("LL hh:mm A")}
                        </TableCell>
                        <TableCell>
                          <ul
                            style={{
                              listStyleType: "none",
                              paddingLeft: 0,
                            }}
                          >
                            {element.narrative.narrative
                              .split("\n")
                              .map((line, i) => (
                                <li
                                  // sx={{ marginTop: 0, marginBottom: 0 }}
                                  key={i}
                                >
                                  {line}
                                </li>
                              ))}
                          </ul>
                        </TableCell>
                        <TableCell align="center">
                          {moment(element.narrative.timestamp).format(
                            "LL hh:mm A"
                          )}
                        </TableCell>
                        <TableCell align="center">Community</TableCell>
                        {/* <TableCell>{`${element.validator.first_name} ${element.validator.last_name}`}</TableCell> */}
                        <TableCell>
                          <ul
                            style={{
                              listStyleType: "none",
                              paddingLeft: 0,
                            }}
                          >
                            {element.remarks.split("\n").map((line, i) => (
                              <li sx={{ marginTop: 1 }} key={i}>
                                {line}
                              </li>
                            ))}
                          </ul>
                        </TableCell>
                        <TableCell align="center">
                          Alert{" "}
                          {element.recommended_alert_level === null
                            ? element.op_trigger
                            : element.recommended_alert_level}
                        </TableCell>
                        <TableCell align="center">
                          Alert {element.op_trigger}
                        </TableCell>

                        <TableCell align="center">
                          <IconButton
                            color="primary"
                            onClick={() => openMomsImageModal(element)}
                            aria-label="upload picture"
                            component="span"
                            style={{ color: "#006A91" }}
                          >
                            <Image />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default MomsTable;
